import {ID} from '~/lib/model';
import {useSession} from '~/modules/Profile/session';
import {IUser, UserRole} from '~/modules/Users/models/User';
import {IUserPermission, PermissionResourceType} from '~/modules/Users/models/UserPermission';

export class Ability {

    private _sellerId: ID = null;
    private _agencyId: ID = null;

    constructor(public user: IUser) {
    }

    agencyId = (): ID => {
        if (this._agencyId) {
            return this._agencyId;
        }
        const permission = this.permission(PermissionResourceType.AGENCY);
        if (permission) {
            this._agencyId = permission.resourceId;
            return this._agencyId;
        }
        return null;
    };

    sellerId = (): ID => {
        if (this._sellerId) {
            return this._sellerId;
        }
        const permission = this.permission(PermissionResourceType.SELLER);
        if (permission) {
            this._sellerId = permission.resourceId;
            return this._sellerId;
        }
        return null;
    };

    isAdmin = () => this.user.role === UserRole.SUPERVISOR || this.user.role === UserRole.ADMIN;

    isManager = () => this.user.role === UserRole.MANAGER;

    isBuyer = () => this.user.role === UserRole.BUYER && this.agencyId();

    isSeller = () => this.user.role === UserRole.SELLER && this.sellerId();

    isSelfServe = () => this.user.role === UserRole.SELFSERVE && this.sellerId();

    isEasybrain = () => this.isSeller() && this.sellerId() === 33;

    enabledFeature = (key: string): boolean => {
        const item = sessionStorage.getItem(key);
        if (item) {
            return item.toString() === 'true';
        }
        return false;
    };

    private permission = (type: PermissionResourceType): IUserPermission => this.user.permissions.find(item => item.resourceType === type);
}

export const useAbility = <T extends Ability>(abilityClass: new (user: IUser) => T): T => {
    const {session} = useSession();
    return new abilityClass(session.user);
};
